module.exports = __webpack_public_path__ + "img/pickaxe.057e811c.png";